import * as React from "react";
const Loader = () => {
  return (
    <div className="loading-EQ-Main-BT">
      <div className="loading-EQ-BT">
        <img src="https://xpertise-manager-assets.s3.amazonaws.com/assets/EQ+Loader.gif" alt="Loading" height={60} width={100} />
      </div>
    </div>
  );
};

export default Loader;
